import Slider1 from '../assets/images/sliders/slider-1.png';
import Slider2 from '../assets/images/sliders/slider-2.png';
import Slider3 from '../assets/images/sliders/slider-3.png';
import Slider4 from '../assets/images/sliders/slider-4.png';

export const heroSlides = [
  {
    id: 1,
    image: Slider1,
    heading: "Admissions Open",
    highlight: "For Academic Year 2025-26",
    sub: "Secure your child's future with quality education from Pre-Nursery to Class 10. Limited seats available for all grades.",
    stats: [
      { value: "Limited", label: "Seats Available" },
      { value: "Early Bird", label: "Discount" },
      { value: "Online", label: "Application" }
    ],
    accentColor: "from-blue-600 to-indigo-500",
    overlayColor: "from-blue-900/40 via-blue-800/30 to-transparent", 
    buttonText: "Apply Now",
    buttonLink: "/admission",
    secondaryButtonText: "Download Brochure",
    secondaryButtonLink: "/brochure",
    ratingText: "CBSE Affiliated • Recognized by Government"
  },
  {
    id: 2,
    image: Slider2,
    heading: "Celebrating Cultural",
    highlight: "Diversity & Traditions",
    sub: "Vibrant cultural festivals, traditional celebrations, and creative arts that enrich our students' learning experience.",
    stats: [
      { value: "10+", label: "Cultural Events" },
      { value: "Traditional", label: "Celebrations" },
      { value: "Arts & Music", label: "Programs" }
    ],
    accentColor: "from-purple-600 to-pink-500", 
    overlayColor: "from-purple-900/40 via-pink-800/30 to-transparent",
    buttonText: "View Gallery",
    buttonLink: "/gallery",
    secondaryButtonText: "Upcoming Events",
    secondaryButtonLink: "/events",
    ratingText: "Promoting Cultural Heritage & Values"
  },
  {
    id: 3,
    image: Slider3,
    heading: "Nurturing Champions",
    highlight: "Through Sports",
    sub: "State-of-the-art sports facilities and professional coaching for overall physical development and teamwork.",
    stats: [
      { value: "15+", label: "Sports Activities" },
      { value: "Inter-School", label: "Champions" },
      { value: "Daily", label: "Sports Period" }
    ],
    accentColor: "from-green-600 to-emerald-500", 
    overlayColor: "from-green-900/40 via-emerald-800/30 to-transparent",
    buttonText: "Sports Facilities",
    buttonLink: "/sports",
    secondaryButtonText: "Meet Coaches",
    secondaryButtonLink: "/coaches",
    ratingText: "Developing Sportsmanship & Fitness"
  },
  {
    id: 4,
    image: Slider4,
    heading: "Building a Greener",
    highlight: "Tomorrow Together",
    sub: "Environmental awareness programs, tree plantation drives, and eco-friendly initiatives for sustainable future.",
    stats: [
      { value: "500+", label: "Trees Planted" },
      { value: "Eco-Club", label: "Active Members" },
      { value: "Green", label: "Campus" }
    ],
    accentColor: "from-teal-600 to-green-500",
    overlayColor: "from-teal-900/40 via-green-800/30 to-transparent",
    buttonText: "Join Eco-Club",
    buttonLink: "/eco-club",
    secondaryButtonText: "Green Initiatives",
    secondaryButtonLink: "/green-initiatives",
    ratingText: "Eco-Friendly School • Green Award Winner"
  }
];

export const sliderSettings = {
  dots: true,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 5000,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  pauseOnHover: true,
};

export const heroConfig = {
  height: {
    mobile: "500px",
    desktop: "600px",
  },
  animationDuration: 0.6,
  progressBarDuration: 4.8,
  ratingStars: 5,
  buttonStyles: {
    primary: "px-6 py-3 font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300",
    secondary: "px-6 py-3 font-semibold rounded-lg border-2 backdrop-blur-sm transition-all duration-300"
  }
};

export const slideThemes = {
  admission: {
    primary: "blue-600",
    secondary: "indigo-500",
    accent: "cyan-400",
    text: "white"
  },
  cultural: {
    primary: "purple-600",
    secondary: "pink-500",
    accent: "fuchsia-400",
    text: "white"
  },
  sports: {
    primary: "green-600",
    secondary: "emerald-500",
    accent: "lime-400",
    text: "white"
  },
  environment: {
    primary: "teal-600",
    secondary: "green-500",
    accent: "emerald-400",
    text: "white"
  }
};